(function(){
  'use strict';

  var modalEl = null;
  var lastScrollY = 0;

  function ensureModal(){
    if (modalEl) return modalEl;
    var tpl = document.getElementById('nuvy-composition-template');
    if (!tpl) return null;
    var node = tpl.content.firstElementChild.cloneNode(true);
    document.body.appendChild(node);
    modalEl = node;

    modalEl.querySelectorAll('[data-nuvy-comp-close]').forEach(function(el){
      el.addEventListener('click', closeModal);
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && modalEl && modalEl.classList.contains('nuvy-comp__modal--open')){
        closeModal();
      }
    });
    return modalEl;
  }

  function openModal(){
    var m = ensureModal();
    if (!m) return;
    lastScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = '-' + lastScrollY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    m.classList.add('nuvy-comp__modal--open');
    m.setAttribute('aria-hidden', 'false');
  }

  function closeModal(){
    if (!modalEl) return;
    modalEl.classList.remove('nuvy-comp__modal--open');
    modalEl.setAttribute('aria-hidden', 'true');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lastScrollY);
  }

  document.addEventListener('click', function(e){
    var trigger = e.target.closest('[data-open-composition]');
    if (trigger){
      e.preventDefault();
      openModal();
    }
  });
})();
